/**
 * @generated SignedSource<<ff1f52c27d3e15392ddf8a5c4767cb6d>>
 * @relayHash 24c98eae456698a33bd5de494f335cbb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/580.0.0-2026-10-07T07:45:34.782Z/profileAboutMutation

import { ConcreteRequest } from 'relay-runtime';
export type DesignProfileBasicMutationInput = {
  about?: string | null;
  clientMutationId?: string | null;
  email?: string | null;
  serviceId: string;
};
export type profileAboutMutation$variables = {
  input: DesignProfileBasicMutationInput;
};
export type profileAboutMutation$data = {
  readonly designProfileBasicMutation: {
    readonly tradeFirm: {
      readonly publicProfile: {
        readonly about: string | null;
      } | null;
    } | null;
  } | null;
};
export type profileAboutMutation = {
  response: profileAboutMutation$data;
  variables: profileAboutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "about",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "profileAboutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DesignProfileBasicMutationPayload",
        "kind": "LinkedField",
        "name": "designProfileBasicMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "profileAboutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DesignProfileBasicMutationPayload",
        "kind": "LinkedField",
        "name": "designProfileBasicMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/580.0.0-2026-10-07T07:45:34.782Z/profileAboutMutation",
    "metadata": {},
    "name": "profileAboutMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cd9de4ad4cdf0c03f4beb634c66cd288";

export default node;
